// Core
import React from "react";

// Assets
import KonnenLogo from "../../assets/konnen-logo-mono-white.svg";

function Logo() {
    return (
        <img src={KonnenLogo} alt="Logo" style={{ height: "40px" }} />
    );
}

export default Logo;
